import { Injector } from "@angular/core";
import { MeddraService } from "../../../../service/meddra-service/meddra.service";
import { MeddraNode } from "../MeddraNode";
import { TreeNodeMeddraLevelItem } from "./TreeNodeMeddraLevelItem";
import { environment } from "../../../../../../environments/environment";
import { Art57Section } from "../../../Art57Section/Art57Section";
import { PTListView } from "../../../Data/MeddraData/PTListView";
import { FieldDefinition } from "../../../../../sections/meddra/message/fieldDefinition";
import { MeddraTerm } from "../../../Data/MeddraData/MeddraTerm";
import { DummyNode } from "../../DummyNode";
import { HierarchyMode, MeddraLevel } from '../../../MeddraEnum';
import { EntityEnum } from "../../EntityEnum";
import { BaseNode } from "../../BaseNode";


export class TreeNodeLLTItem extends TreeNodeMeddraLevelItem {

    constructor(injector: Injector, data: any, parent: BaseNode) {
        super(injector, data, EntityEnum.llt, injector.get(Art57Section).meddra.lltTermsTreeNode, parent);
        this.children?.push(new DummyNode());
    }

    override createChildren(): void {
        //Retrieve "Preferred term for this HLG term"
        let ptNode = new MeddraNode(this.ioc!, new PTListView([]), `Preferred Terms ({param})`, EntityEnum.pt, null, this, HierarchyMode.ASCENDING);
        this.children!.push(ptNode);
        this.ioc?.get(MeddraService).getAll(this,EntityEnum.pt, `llt_code:eq:${this.data.model.code}`).subscribe(
            {
                next: (data:any) => {
                    ptNode.data = new PTListView(data.result);
                    data.result.forEach((i: any) => ptNode.children!.push(new MeddraNode(this.ioc!, new MeddraTerm(new FieldDefinition(this.ioc!).ptFields, i), i.name, EntityEnum.pt, this.ioc!.get(Art57Section).meddra.ptTermsTreeNode, ptNode, HierarchyMode.ASCENDING)))
                    ptNode.refreshLabel();
                }, error: () => {
                    this.ioc!.get(Art57Section).showTooltipMessage({ severity: 'error', detail: 'Error found', life: environment.errorElapsedTime });
                }
            });
    }
}